const name = 'circle';


const contents = `
  <circle cx="31" cy="41" r="29"/>
`;


/** @type {import ('./types').Icon} */
const icon = {
  name,
  contents,
};

export default icon;
